<template>
  <div class='step3'>
    <a-card size='small' hoverable>
      <div class='header'><b>元素数据源</b><a-button @click='addDataSource()' type="primary" size='small' style='float: right'>添加</a-button></div>
      <a-divider style='margin: 12px 0'/>
      <div class='list'>
        <div class='list-item' v-for='(item,index) in model.itemList'>
          <a-space :size='12'>
            <span style="width: 80px;display: inline-block;text-align: right">数据源{{index + 1}}：</span>
            <a-select v-model='item.formId' placeholder='请选择表单' style='width: 200px' showSearch :filterOption="filterOption"  @change="formIdChange(item)" >
              <a-select-option  :value='form.id' :key="form.id" v-for="form in formList">{{form.name}}</a-select-option>
            </a-select>
            <a-select v-model='item.formItemId' placeholder='请选择元素' style='width: 500px' showSearch :filterOption="filterOption" @change="formItemChange(item)">
              <a-select-option :value='formItem.id' :key="formItem.id" v-for="formItem in item.formItemList">{{formItem.number || ""}}{{formItem.name}}</a-select-option>
            </a-select>
            <span><a-icon type="close" @click='removeDataSource( index)'/></span>
            <!-- <span v-if="item.isCheckValue">多选题：              
              <a-radio-group v-model="item.checkValueType">
                <a-radio value="1">选项值求和</a-radio>
                <a-radio value="2">保留原值</a-radio>
              </a-radio-group>
            </span> -->
          </a-space>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'
export default {
  name: 'Step2',
  components: {  },
  data() {
    return {
      model:{},
      formList:[],
    }
  },
  created() {

  },
  methods: {
    view(model){
      this.model = JSON.parse(JSON.stringify(model))
      if(!this.model.itemList || this.model.itemList.length===0){
        this.$set(this.model,'itemList',this.model.itemList || [])
        this.model.itemList.push({
          formItemId:model.formItemId,
          periodRule:'2',
          formId:model.formId,
        })
      }
      getAction('/tempconfig/tempConfigForm/listAll',{id:model.formId}).then(res=>{
        if(res.success){
          this.formList=res.result

          this.$nextTick(()=>{
            this.model.itemList.forEach(item=>{
              if(item.formId){
                let formCode;
                for (let im of this.formList) {
                  if (im.id === item.formId) {
                    formCode = im.code
                    break
                  }
                }
                getAction('/tempconfig/tempConfigFormItem/listAll',{formCode:formCode,scale:'0'}).then(res=>{
                  if(res.success){
                    // item.formItemList = res.result
                    this.$set(item,'formItemList',res.result)
                    this.formItemChange(item)
                  }
                })
              }
            })
          })
        }
      })
      
    },
    formIdChange(item){
      this.$set(item,'formItemList',[])
      if(item.formItemId){
        item.formItemId = null
      }
      if(item.formId){
        let formCode;
            for (let im of this.formList) {
              if (im.id === item.formId) {
                formCode = im.code
                break
              }
            }
        getAction('/tempconfig/tempConfigFormItem/listAll',{formCode:formCode,scale:'0'}).then(res=>{
          if(res.success){
            // item.formItemList = res.result
            this.$set(item,'formItemList',res.result)
          }
        })
      }
    },
    formItemChange(item){
      console.log("formItemChange")
        let items = item.formItemList.filter(i=>i.id == item.formItemId)
        if(items && items.length > 0){
          if(items[0].type=='check'){
            this.$set(item,'isCheckValue',true)
            if(!item.checkValueType){
              this.$set(item,'checkValueType',"1")
            }else{
              this.$set(item,'checkValueType',item.checkValueType+'')
            }
          }else{
            this.$set(item,'isCheckValue',false)
          }
        }        
    },
    /**
     * 添加数据源
     */
    addDataSource() {
      this.model.itemList.push({periodRule:'2'})
    },
    /**
     * 移除数据源
     * @param index
     */
    removeDataSource(index) {
      this.model.itemList.splice(index, 1)
    },

    validate() {
      /*简陋验证逻辑,请修改*/
      if(!this.model.itemList || this.model.itemList.length===0){
        this.$message.warning("请添加元素数据源")
        return false
      }
      let error = false
      this.model.itemList.forEach((item,index) =>{
        if(error){
          return
        }
        if(!item.formId || !item.formItemId){
          this.$message.warning(`数据源${index+1}请填写完整`)
          error = true
        }
      })
      if(error){
        return false
      }
      // if(this.model.type!=3){
      // const itemIdList = []
      // this.model.itemList.forEach((item,index)=>{
      //   if(error){
      //     return
      //   }
      //   if(itemIdList.indexOf(item.formItemId)>=0){
      //     error = true
      //     this.$message.warning(`数据源${index+1}重复添加`)
      //   }else{
      //     itemIdList.push(item.formItemId)
      //   }
      // })
      // }
      if(error){
        return false
      }
      this.model.itemList.forEach((item) =>{
        const formName=this.formList.filter(form=> form.id===item.formId)[0].name
        let formItem = item.formItemList.filter(formItem=> formItem.id===item.formItemId)[0]
        item.name=`【${formName}.${formItem.number}.${formItem.name}】`
      })
      return true
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
  }
}
</script>

<style scoped>
.step3 {
  padding: 0 80px;
}
.header {
  font-size: 16px;
}
.list{
  text-align: center;
}
.list > .list-item {
  margin: 12px auto;
  text-align: left;
  width: 1200px;
}
</style>
